import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin, Select, Row, Col, DatePicker, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';
import context from '../../public/js/context';
import trans from './translation';
import moment from 'moment';//日期格式化导包

const { Option } = Select;

const UpdateStaffRoleModal = (props) => {
    const messageRef = useRef();
    const [isDisabled, setIsDisabled] = useState(true);
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [academicStaffModel, setAcademicStaffModel] = useState(props.academicStaffModel);
    const [spinInfo, setSpinInfo] = useState("");

    useEffect(() => {
        initForm(academicStaffModel)
    }, []);

    const initForm = (model) => {
        form.setFieldsValue({
            roleCode: model.roleCode ?? "",
            progCode: model.progCode ?? "",
            progTitle: model.progTitle ?? "",
            receiveNotiInd: model.receiveNotiInd ?? "",
            wpaStandApproveInd: model.wpaStandApproveInd ?? "",
            jobappStandApproveInd: model.jobappStandApproveInd ?? "",
        });
    }

    const save = () => {
        form.submit();
    }

    const onFinish = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        model.staffUserRoleId = academicStaffModel.staffUserRoleId
        model.lastUpdatedDate = academicStaffModel.lastUpdatedDate;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("academicStaff/updateStaffUserRole", model).then((data) => {
            if ("SUCCESS" == data.msg) {
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
                onCancel(true)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    const handleChange = (value) => {
        if (value === 'N') {
            form.setFieldValue('inactiveDate', moment());
            setIsDisabled(false)
        } else {
            form.setFieldValue('inactiveDate', null);
            setIsDisabled(true)
        }
    }

    return (
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                className='studentProgFormModal'
                visible={true}//控制弹框是否显示
                title="Edit Staff Role"//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'1000px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <Form form={form} onFinish={onFinish}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam sysParamInput ">Role Code</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="roleCode"
                                >
                                    <Input type="text" placeholder="Role Code" disabled />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysParam sysParamInput ">Programme Code</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="progCode"
                                >
                                    <Input type="text" placeholder="Programme Code" disabled />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysParam sysParamInput ">Programme Name</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="progTitle"
                                >
                                    <Input type="text" placeholder="Programme Name" disabled />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="sysCol">
                            <div className="sysParam mustFill">Job App Standing Approval</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="jobappStandApproveInd"
                                    rules={[
                                        { required: true, message: 'Job App Standing Approval is required.' },
                                    ]}
                                >
                                    <Select className='sysSelect' disabled={academicStaffModel?.roleCode === "PROGRAMME_LEADER" || academicStaffModel?.roleCode === "ACADEMIC_SUPERVISOR"} >
                                        <Option value=''></Option>
                                        {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className="sysCol">
                            <div className="sysParam mustFill">WPA Standing Approval</div>
                            <div className="sysInput">
                                <Form.Item
                                    name="wpaStandApproveInd"
                                    rules={[
                                        { required: true, message: 'WPA Standing Approval is required.' },
                                    ]}
                                >
                                    <Select className='sysSelect' disabled={academicStaffModel?.roleCode === "PROGRAMME_LEADER"}>
                                        <Option value=''></Option>
                                        {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>
        </Spin>
    )

}

UpdateStaffRoleModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    academicStaffModel: PropTypes.object.isRequired,
}

export default UpdateStaffRoleModal;